angular.module('tct.businessInfoService', ['tct.configService'])
  .factory('businessInfoService', businessInfoService);

businessInfoService.$inject = ['configService', '$http'];

function businessInfoService(config, $http) {
  const basePath = `${config.APP_PROTOCOL}://${config.APP_API}:${config.APP_API_PORT}/api/business-informations`;
  const factory = {
    getBusinessInfoOrder,
    updateBusinessInfoNotes,
    setBusinessInfoCompleted,
    setBusinessInfoToDraft,
  };

  return factory;

  function getBusinessInfoOrder(id) {
    const url = `${basePath}/${id}`;
    return $http.get(url);
  }

  function updateBusinessInfoNotes(id, notes, score, trustStatement, companyContacts) {
    const url = `${basePath}/${id}`;
    return $http.put(url, {
      notes: JSON.stringify(notes),
      score,
      trust_statement: trustStatement,
      company_contacts: JSON.stringify(companyContacts),
    });
  }

  function setBusinessInfoCompleted(id, notes, score, trustStatement, companyContacts) {
    const url = `${basePath}/${id}/complete`;
    return $http.put(url, {
      notes: JSON.stringify(notes),
      score,
      trust_statement: trustStatement,
      company_contacts: JSON.stringify(companyContacts),
    });
  }

  function setBusinessInfoToDraft(businessInfoId) {
    const url = `${basePath}/${businessInfoId}/status`;
    return $http.put(url, { status: 'draft' });
  }
}
